import React from 'react'

function Header4({ className = 'text-gray', children }) {
  return (
    <h4 className={`${className} header4`} style={{ fontWeight: 'normal' }}>{children}</h4>
  )
}

export default Header4